import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { LanguageService } from "@spotter/services/internal/language-service";
import { QuestionsService } from "@spotter/services/sightings/questions-service";

/** An `APP_INITIALIZER` function to load the requested language before loading the rest of the app.
 *  Will set the default language and load the correct upload questions.
 */
@Injectable({
    providedIn: 'root'
})
export class LanguageInitialiser {

    callbackFunction?: Function;

    constructor(public lang: TranslateService, public languageService: LanguageService, public questions: QuestionsService)
    {
      
    }

    /** Initialises the language features of the Spotter platform */
    initialise(callbackFunction?: Function): Promise<boolean> {
        this.callbackFunction = callbackFunction;

        return new Promise(async resolve => {
            await this.setDefaultLanguage();
            await this.loadQuestions();
            resolve(true);
        });
    }

    /** Sets the default language to use */
    private setDefaultLanguage()
    {
        return new Promise(resolve => {
            this.lang.use(this.languageService.language.code).subscribe({
                next: (d: any) => {
                    if (this.callbackFunction)
                        this.callbackFunction();
                    resolve(true);
                },
                error: (e: any) => {
                    console.error("Unable to find the requested language. Will fallback to English");
                    if (this.callbackFunction)
                        this.callbackFunction();
                    resolve(false);
                }
            });
        });
    }

    /** Loads the sighting and absence questions in the correct language if available */
    private loadQuestions()
    {
        return new Promise(resolve => {
            this.questions.initialise().then(
                done => {
                    if (this.callbackFunction)
                        this.callbackFunction();
                    resolve(true);
                }
            )
        });
        
    }
}